import Form from './Form.jsx';
import FormIsValid from './FormIsValid.tsx';
import useFormValidation from './useFormValidation.ts';

Form.IsValid = FormIsValid;

export default Form;
export { useFormValidation, FormIsValid };
